<template>
  <div class='h100-40 width-100vw h-scroll'>
    <ejs-grid ref='grid' height='calc(100% - 0px)' :dataSource='indicatorThresholdData' :contextMenuItems="contextMenuItems" :contextMenuOpen='menuBeforeOpenFunc' :contextMenuClick='menuClickFunc'
              :selectionSettings='selectionOptions' :allowReordering='true' :allowResizing='true' >
      <e-columns>
        <e-column type='checkbox' textAlign='Center' width='66'></e-column>
        <e-column field='transformNodeNameArr' :headerText='$t("Topo.equipmentList")' textAlign='Center' minWidth='10' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='activeState' :headerText='$t("NSMF.administrativeState")' :formatter='formatActiveState' textAlign='Center' minWidth='10' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='createTime' :headerText='$t("SubscriberIms.createtime")' textAlign='Center' minWidth='10' type='date' :format='dateFormatOptions' clipMode='EllipsisWithTooltip'></e-column>
      </e-columns>
    </ejs-grid>
    <ejs-pager ref='pager' @click='getBusyTimeIndicatorAlarmThresholdListData()' :currentPage='page.pageNo' :pageSize='page.pageSize' :totalRecordsCount='page.totalCount' :pageCount='page.pageCount'></ejs-pager>
    <CustomDialog ref='addDialog' :element='addDialogSetting.element' :styles='addDialogSetting.styles'>
      <template v-slot:dialog-content>
        <AddBusyTimeIndicatorThreshold ref='addContent'></AddBusyTimeIndicatorThreshold>
      </template>
    </CustomDialog>
  </div>
</template>

<script>
import { Reorder, Resize, ContextMenu } from '@syncfusion/ej2-vue-grids';
import CustomDialog from '../../common/CustomDialog';
import { EventBus } from '../../../plugins/eventBus';
import AddBusyTimeIndicatorThreshold from "./AddBusyTimeIndicatorThreshold"

export default {
  name: "busyTimeIndicatorThresholdTable",
  components: {
    CustomDialog,
    AddBusyTimeIndicatorThreshold
  },
  data() {
    return {
      selectionOptions: { type: 'Multiple' },
      dateFormatOptions: { type: 'date', format: 'yyyy-MM-dd HH:mm:ss' },
      contextMenuItems: [{
        text: `${this.$t('Alarm.add')}`
      }, {
        text: `${this.$t('Alarm.remove')}`
      }, {
        text: `${this.$t('Alarm.edit')}`
      }, {
        text: `${this.$t('Alarm.refresh')}`
      }, {
        text: `${this.$t('Alarm.able')}`
      }, {
        text: `${this.$t('Alarm.disable')}`
      }],
      page: {
        pageNo: 1,
        pageSize: 15,
        totalCount: 0,
        pageCount: 10
      },
      indicatorThresholdData: [],
      addDialogSetting: {
        styles: {
          width: '850px',
          height: 'auto',
          model: true,
          visible: false
        },
        element: {
          title: this.$t('Alarm.addBlockingRule'),
          refName: 'add',
          isClose: true,
          buttonGroup: [
            { click: this.dialogHide, buttonModel: { content: this.$t('Alarm.cancel') } },
            { click: this.addConfirmFunc, buttonModel: { content: this.$t('Alarm.confirm'), isPrimary: true } }
          ]
        }
      }
    };
  },
  methods: {
    menuBeforeOpenFunc(menuArgs) { // 屏蔽表头的右键事件
      if (!menuArgs.rowInfo.rowIndex && menuArgs.rowInfo.rowIndex !== 0) {
        menuArgs.cancel = true;
      }
      const childList = menuArgs.element.querySelectorAll('li.e-menu-item');
      if (this.getCheckedData(true).length > 1) {
        childList[2].style.display = 'none';
      } else {
        childList[2].style.display = 'block';
      }
    },
    menuClickFunc(menuArgs) { // 为右键分配事件
      console.log("******menuArgs:", menuArgs)
      switch (menuArgs.element.innerText) {
        case `${this.$t('Alarm.add')}`:
          this.addFunc();
          break;
        case `${this.$t('Alarm.remove')}`:
          this.removeFunc();
          break;
        case `${this.$t('Alarm.edit')}`:
          this.editFunc();
          break;
        case `${this.$t('Alarm.refresh')}`:
          this.getBusyTimeIndicatorAlarmThresholdListData();
          break;
        case `${this.$t('Alarm.able')}`:
          this.updateStatusFunc('1');
          break;
        case `${this.$t('Alarm.disable')}`:
          this.updateStatusFunc('0');
          break;
        default:
      }
    },
    formatActiveState(grids, data) {
      return data.activeState == '0' ? this.$t('Pm.hangup') : this.$t('Security.Lic.activeStatus_activated');
    },
    dialogHide() {
      this.$refs.addDialog.clear();
      this.$refs.addDialog.close();
    },
    getCheckedData(selectOnly) {
      // false: 不支持多选   true: 支持多选
      const selectedRecords = this.$refs.grid.getSelectedRecords();
      if (selectedRecords.length < 1) {
        EventBus.$emit('toast', {type: 'warning', content: this.$t('Alarm.no_checked')});
        return false;
      }
      if (selectedRecords.length > 1 && !selectOnly) {
        EventBus.$emit('toast', {type: 'warning', content: this.$t('Common.tips.onlyOneSelect')});
        return false;
      }
      return selectedRecords;
    },
    getCheckedVals() {
      const ids = [];
      const checkedData = this.getCheckedData(true);
      for (let i = 0; i < checkedData.length; i++) {
        ids.push(checkedData[i].id);
      }
      return ids;
    },
    getBusyTimeIndicatorAlarmThresholdListData() {
      //获取表格数据
      const This = this;
      This.page.pageNo = This.$refs.pager.ej2Instances.currentPage;
      This.$axios.post('/lte/pm/indicator/getBusyTimeIndicatorAlarmThresholdList', {
        pageNo: This.page.pageNo,
        pageSize: This.page.pageSize
      }).then((response) => {
        if (response && response.data.errorCode === 'SUCCESS') {
          const result = response.data.resultVal;
          This.page.totalCount = result.totalCount;
          This.indicatorThresholdData = result.result;
          This.indicatorThresholdData.forEach(item => {
            var subStr =item.nodeNameArr.slice(1, item.nodeNameArr.length -1 ).replace(/"/g, "");
            item.transformNodeNameArr = subStr;
          })
        }
      });
    },
    addFunc() {
      this.addDialogSetting.element.title = this.$t('Alarm.addBusyTimeIndicatorAlarmThreshold');
      this.$refs.addDialog.show();
      this.$refs.addContent.clearData();
      this.$refs.addContent.timeRangeLabelArray.push({
        dateRangeBeginTime: '',
        dateRangeEndTime: '',
      });
    },
    addConfirmFunc() {
      const This = this;
      const indicatorThresholdData = This.$refs.addContent.getIndicatorThresholdData();

      if (indicatorThresholdData == false) {
        return;
      } else {
        let url = '/lte/pm/indicator/insertBusyTimeIndicatorAlarmThreshold';
        if (this.addDialogSetting.element.title !== this.$t('Alarm.addBusyTimeIndicatorAlarmThreshold')) {
          url = '/lte/pm/indicator/updateBusyTimeIndicatorAlarmThreshold';
        }

        var errorName = "";
        const checkNodeIdArrStr = indicatorThresholdData.nodeIdArr;
        const checkNodeNameArrStr = indicatorThresholdData.nodeNameArr;

        var checkNodeIdArr = JSON.parse(checkNodeIdArrStr);
        var checkNodeNameArr = JSON.parse(checkNodeNameArrStr);
        this.indicatorThresholdData.forEach(item => {
          var dbNodeIdArr = JSON.parse(item.nodeIdArr);
          for (let i = 0; i < checkNodeIdArr.length; i++) {
            if (dbNodeIdArr.includes(checkNodeIdArr[i]) && item.id != indicatorThresholdData.id) {
              const commaCount = errorName.split(',').length - 1;
              if (commaCount < 5) {
                errorName = errorName + checkNodeNameArr[i] + ",";
              } else if (commaCount == 5){
                if (errorName !== "") {
                  errorName = errorName + "...,";
                }
              }
            }
          }
        })

        if (errorName != "") {
          EventBus.$emit('toast', {type: 'error', content: (errorName + this.$t('Alarm.theDeviceIsOccupied'))});
        } else if (indicatorThresholdData !== false) {
          This.$axios.post(url, indicatorThresholdData).then((response) => {
            if (response && response.data.errorCode === 'SUCCESS') {
              EventBus.$emit('toast', {type: 'success', content: This.$t('Alarm.success')});
              This.dialogHide();
              This.getBusyTimeIndicatorAlarmThresholdListData();
            } else {
              EventBus.$emit('toast', {type: 'error', content: This.$t('Alarm.error')});
            }
          });
        }
        this.getBusyTimeIndicatorAlarmThresholdListData();
      }
    },
    removeFunc() {
      // 删除规则
      const This = this;
      const checkedData = This.getCheckedData(true);
      var selectedIdArr = "";

      if (checkedData) {
        This.$layer.confirm({
          msg: This.$t('Alarm.alarmDeleteConfirm'),
          btn1: {
            msg: This.$t('Alarm.cancel')
          },
          btn2: {
            msg: This.$t('Alarm.confirm'),
            func: () => {
              if (checkedData.length > 0) {
                for (var i = 0; i < checkedData.length; i++) {
                  selectedIdArr = selectedIdArr + checkedData[i].id + ","
                }
              }
              var param = {
                "idsArr" : selectedIdArr
              };

              This.$axios.post('/lte/pm/indicator/batchDeleteBusyTimeIndicatorAlarmThresholdById', param).then((response) => {
                if (response && response.data.errorCode === 'SUCCESS') {
                  EventBus.$emit('toast', {type: 'success', content: This.$t('Alarm.success')});
                } else {
                  EventBus.$emit('toast', {type: 'error', content: This.$t('Alarm.error')});
                }
                This.getBusyTimeIndicatorAlarmThresholdListData();
              });
            }
          }
        });

      }
    },
    editFunc() {
      // 修改规则
      const This = this;
      This.addDialogSetting.element.title = This.$t('Alarm.modifyBusyTimeIndicatorAlarmThreshold');
      const checkedData = This.getCheckedData(false);

      if (checkedData) {
        if (checkedData[0].activeState == "1") {
          EventBus.$emit('toast', {type: 'error', content: This.$t('Monitor.task.activeMonitor')});
          return false;
        }
        This.$refs.addDialog.show();
        This.$refs.addContent.setParams(checkedData[0]);
      }
    },
    updateStatusFunc(statusStr) {
      const This = this;
      const checkedData = This.getCheckedData(false);
      let str = '';
      switch (statusStr) {
        case '1':
          str = This.$t('Track.activation');
          break;
        case '0':
          str = This.$t('Track.hangup');
          break;
        default:
      }
      if (checkedData) {
        This.$layer.confirm({
          msg: `${str}?`,
          btn1: {
            msg: this.$t('Alarm.cancel')
          },
          btn2: {
            msg: this.$t('Alarm.confirm'),
            func: () => {
              This.$axios.post('/lte/pm/indicator/updateBusyTimeIndicatorAlarmThreshold', {
                activeState: statusStr,
                id: checkedData[0].id
              }).then((response) => {
                if (response && response.data.errorCode === 'SUCCESS') {
                  EventBus.$emit('toast', {type: 'success', content: this.$t('Alarm.success')});
                } else {
                  EventBus.$emit('toast', {type: 'error', content: this.$t('Alarm.error')});
                }
                This.getBusyTimeIndicatorAlarmThresholdListData();
              });
            }
          }
        });
      }
    }
  },
  mounted() {
    this.getBusyTimeIndicatorAlarmThresholdListData();
  }

}
</script>

<style scoped>

</style>
